import Entity from "./Entity";

export default Entity;
